/**
 * /cloud-vps — migrated from public/js/cloud-vps.js.
 * 1. Sticky-bookmarks (shared)
 * 2. .layer-1 .col click → toggle .featured
 * 3. .layer-terms accordion (h2 → slideToggle wrapper)
 * 4. .v-cloud .layer-3 .col Tooltip
 * 5. Switch packages (shared)
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';
import { initSwitchPackages } from '../shared/switch-packages.js';

new Resort(() => {
    initStickyBookmarks();

    ($('.layer-1 .col', true) as NodeListOf<Element>).on('click', function (this: Element) {
        (this.parentElement?.find('.featured') as Element | null)?.classList.remove('featured');
        this.classList.add('featured');
    });

    ($('.layer-terms') as Element | null)?.on('click', 'h2', function (this: Element) {
        this.classList.toggle('active');
        ($('.layer-terms .wrapper') as HTMLElement | null)?.slideToggle();
    });

    ($('.v-cloud .layer-3 .col', true) as NodeListOf<Element>).Tooltip();

    initSwitchPackages('header .switch-btn');
});
